import Component from 'components/component'
import { Link } from 'components/link'
import { DI } from 'modules'
import React from 'react'

export class RequestSent extends Component {
  render() {
    const {
      common: { strings },
      name,
    } = this.props

    return (
      <div className="payments-notification-container">
        <div className="payments-notification-inner">
          <span className="payments-notification__ico payments-notification__ico--success" />
          <span className="payments-notification__title">
            {strings[`page.request_plan.${name}.success.title`]}
          </span>
          <div className="payments-notification__text">
            <p className="_not-padded">
              {strings[`page.request_plan.${name}.success.text_1`]}
            </p>
            <p className="_not-padded">
              {strings[`page.request_plan.${name}.success.text_2`]}
            </p>
            <p className="_not-padded">
              {strings[`page.request_plan.${name}.success.text_3`]}
            </p>
            <p>
              <Link className="button payments-notification__button" to="/">
                {strings[`page.request_plan.${name}.success.link`]}
              </Link>
            </p>
          </div>
        </div>
      </div>
    )
  }
}

export default DI([])(RequestSent)
